<template>
	<el-container>
		<div class="menulist">
			<ul>
				<li>商品明细</li>
				<li>
					<ul>
						<li>
							<span class="spanlabel">商品名称：</span>
							<span class="spantxt">{{goodsEnt.goods_name}}</span>
						</li>
						<li>
							<span class="spanlabel">商品描述：</span>
							<span class="spantxt">{{goodsEnt.goods_detail}}</span>
						</li>
						<li>
							<span class="spanlabel">原价：</span>
							<span class="spantxt">{{goodsEnt.goods_orgprice}}</span>
							<span class="spanlabel">售价：</span>
							<span class="spantxt">{{goodsEnt.goods_saleprice}}</span>
						</li>
					</ul>

				</li>
				<li>基本操作</li>
				<li>
					<ul>
						<li>
							<el-button @click="btnDiscount">按折扣调价</el-button>
							<el-input style="width: 160px;" type="number" placeholder="请输入折扣" v-model="avgdiscount"></el-input>

						</li>
						<li>
							<el-button @click="btnAvg">按总价平摊</el-button>
							<el-input style="width: 160px;" type="number" placeholder="请输入平摊金额" v-model="avgcash"></el-input>

						</li>
					</ul>
				</li>
				<!-- <li><h3>当前分组：{{groupEnt.GroupName}}[分组金额：{{groupEnt.GroupPrice}}][适用性别：{{groupEnt.Sex}}]</h3></li> -->

			</ul>
			<ul>
				<li>
					<el-button @click="btnOK">保存项目</el-button>
				</li>
				<li>
					<ul>
						<li>

							<div style="width: 40%;float: left;">
								<ul>
									<li>
										已选项目{{SelTotal}}
									</li>
									<li>
										<el-table size='mini' border @row-dblclick="SelItemdbclick" tooltip-effect="dark" :data="SelSaleModuleList">
											<el-table-column prop="SaleModuleName" label="项目名称" width="120px"></el-table-column>
											<el-table-column prop="CurPrice" label="售价" width="50px"></el-table-column>
											<el-table-column prop="Discount" label="折扣" width="50px"></el-table-column>
											<el-table-column prop="OrgPrice" label="原价" width="50px"></el-table-column>
										</el-table>
									</li>
								</ul>
							</div>
							<div style="width: 60%;float: left;">
								<ul>
									<li>
										<h3>系统项目</h3>
									</li>
									<li>
										<el-input type="text" v-model="txtFind" placeholder="项目名称拼音首字母查找" @input="FindTextChange()"></el-input>
									</li>
									<li>
										<el-table size='mini' border ref="multipleTable" @row-dblclick="SysItemdbclick" tooltip-effect="dark" :data="SaleModuleListShow.slice((currentPage-1)*pagesize,currentPage*pagesize)">
											<el-table-column prop="SaleModuleName" label="项目名称" width="120px"></el-table-column>
											<el-table-column prop="CurPrice" label="售价" width="100px"></el-table-column>
											<el-table-column prop="MiniDiscount" label="最低折扣" width="50px"></el-table-column>
											<el-table-column prop="OrgPrice" label="原价" width="50px"></el-table-column>
											
										</el-table>
										<el-footer style="margin-top:20px;">
											<template>
												<div class="block">
													<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
													 :page-sizes="[5, 10, 20, 40]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
													 :total="SaleModuleListShow.length"></el-pagination>
												</div>
											</template>
										</el-footer>
									</li>
								</ul>


							</div>
						</li>

					</ul>


				</li>
			</ul>

		</div>

	</el-container>
</template>

<script>
	import goods from '../../apifunction/Goods.js'
	import groupitem from '../../apifunction/GroupItem.js'
	import salermodul from '../../apifunction/SalerModul.js'
	import py from '../../commontools/chineseToPinYin.js'
	export default {
		created() {
			this.goodsEnt = JSON.parse(this.$route.query.ent);
			this.initData();

		},
		data() {
			return {
				currentPage: 1,
				pagesize: 10,
				userent: this.$myglobal.getUserInfo(),
				goodsEnt: null,
				avgcash: 0,
				avgdiscount: 1,
				SelTotal: '',
				txtFind: '',
				txtMName: '',
				SelSaleModuleList: [],
				SaleModuleListAll: [],
				SaleModuleListShow: [],
				SaleItemAll: []
			}
		},
		methods: {
			initData() {
				this.InitAllSaleModule();
				this.InitSaleItemAll();
				this.InitSelSaleModules();
			},
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			btnAvg: function() {
				groupitem.ChangeItemPrice(this.SelSaleModuleList, this.avgcash, '', this.SaleItemAll)
				this.ShowSelTotal();
			},
			btnDiscount: function() {
				groupitem.ChangeItemPrice(this.SelSaleModuleList, '', this.avgdiscount, this.SaleItemAll)
				this.ShowSelTotal();
			},
			FindTextChange: function() {
				if (this.txtFind == '') {
					this.SaleModuleListShow = JSON.parse(JSON.stringify(this.SaleModuleListAll));
					return;
				}
				//alert(py.chinesesToPY(this.SaleModuleListAll[0].SaleModuleName))
				var templist = this.SaleModuleListAll.filter(item => {
					if (item.py.toLowerCase().indexOf(this.txtFind.toLowerCase()) > -1) {
						//if (item.SaleModuleName.indexOf(this.txtFind) > -1) {
						return item
					}
				});
				this.SaleModuleListShow = JSON.parse(JSON.stringify(templist));
			},

			InitSaleItemAll: function() {

				groupitem.GetSaleItemAll(this.userent.corpid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data == 'null')
								return;
							this.SaleItemAll = JSON.parse(ent.Data);

						}
					})
			},
			InitAllSaleModule: function() {
				groupitem.GetSaleModuleValid(this.userent.corpid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {

							this.SaleModuleListAll = JSON.parse(ent.Data);
							for (let i = 0; i < this.SaleModuleListAll.length; i++) {
								this.SaleModuleListAll[i].py = py.chinesesToPY(this.SaleModuleListAll[i].SaleModuleName)
							}
							this.SaleModuleListShow = JSON.parse(ent.Data);

						}
					})
			},
			InitSelSaleModules: function() {
				goods.GetGoodsItemByGoodsid(this.goodsEnt.goods_id)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data));
						if (ent.Flag == 'success') {
							if (ent.Data == 'null')
								return;
							var list = JSON.parse(ent.Data);
							for (let i = 0; i < list.length; i++) {
								var item = this.GetSelSaleModule(list[i]);
								this.SelSaleModuleList.push(list[i])
							}
							this.ShowSelTotal();
						}
					})
			},
			ShowSelTotal: function() {
				if (this.SelSaleModuleList == null || this.SelSaleModuleList.length < 1)
					this.SelTotal = '【无项目】';
				else {
					let sum = 0;
					let salesum = 0;
					for (let i = 0; i < this.SelSaleModuleList.length; i++) {
						var li = this.SelSaleModuleList[i];
						sum += parseFloat(li.OrgPrice);
						salesum += parseFloat(li.CurPrice);
					}
					this.SelTotal = '【总计：原价' + parseFloat(sum).toFixed(1) + ';售价' + parseFloat(salesum).toFixed(1) + ';折扣' +
						parseFloat(
							salesum / sum).toFixed(4) + '】';
				}
			},
			SysItemdbclick(item, event) {
				var ent = this.GetSelSaleModule(item);
				let obj = this.SelSaleModuleList.find(v => v.SaleModuleID === ent.SaleModuleID);
				if (obj) {
					this.$message.info('项目已存在！')
				} else {

					var msg = groupitem.CheckRepeatItem(ent, this.SelSaleModuleList, this.SaleItemAll)
					if (msg == '') {
						this.SelSaleModuleList.push(ent)
						this.ShowSelTotal();
					} else
						this.$message.info(msg);
				}
			},
			SelItemdbclick: function(item, event) {
				let index = this.SelSaleModuleList.findIndex(f => f.SaleModuleID == item.SaleModuleID);
				this.SelSaleModuleList.splice(index, 1)
				this.ShowSelTotal();
			},
			GetSelSaleModule: function(ent) {
				return {
					goods_id: this.goodsEnt.goods_id,
					goods_name: this.goodsEnt.goods_name,
					SaleModuleID: ent.SaleModuleID,
					SaleModuleName: ent.SaleModuleName,
					OrgPrice: ent.OrgPrice,
					Discount: ent.Discount,
					CurPrice: ent.CurPrice,
					MiniDiscount: 0
				}
			},
			btnOK: function() {
				if (this.SelSaleModuleList.length < 1) {
					this.$message.info('请选择体检项目！');
					return;
				}
				goods.SaveGoodsItem(this.goodsEnt.goods_id, this.SelSaleModuleList)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.$message.info('保存成功！');
this.$router.push("goods")
						} else
							this.$message.info(ent.Msg);
					})

			}
		}

	}
</script>
